<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents" v-if="!isRendering">
      <h1 class="l-pageTitle"><img src="@/assets/img/common/icon-nav8_blue.svg" alt="">人的資本管理</h1>

      <div class="l-contentsBox">
        <!-- CSVファイルアップロード -->
        <div class="l-contentsSection">
          <h2 class="heading-lv2">業界平均値</h2>
          <p class="l-text">CSVファイルをアップしてください。</p>
          <div class="l-grayBox u-mt30 u-mb10 is-flex">
            <div class="l-fileinput"><input type="file" id="upload" v-on:change="fileSelected"></div>
            <div class="btn-basic is-inlne is-primary is-small"  @click="fileUpload()"><button>アップロード</button></div>
            <div class="btn-download is-inlne is-primary is-small"  @click="templateCsvFileDownload()"><button>CSVフォーマットのダウンロード</button></div>
          </div>

          <div v-if="this.importErrorMessages.length > 0" class="error">
            <p class="l-text" v-for="message in this.importErrorMessages" :key="message"> {{message}}</p>
          </div>
        </div>

        <!-- 人的資本　取込ガイドコード設定 -->
        <div class="l-contentsSection">
          <h2 class="heading-lv2">取り組みガイド</h2>
          <p class="l-text u-mb20">ガイドコードを入力してください。</p>
          <div v-if="this.$v.$invalid" class="error">
            <p class="l-text">ガイドコードには４桁の数字を入力してください。</p>
          </div>
          <table class="l-form-table u-mt30">
            <tbody>
              <tr>
                <th class="v-middle"><span>採用女性労働者割合</span></th>
                <td class="v-middle"><div class="l-inputAccount w-short">
                  <TextBox v-model.trim="$v.guideCode.femalePercentage.$model" type="text" name="guideCode.femalePercentage" @input="changeInput()"></TextBox>
                </div></td>
                <th class="v-middle"><span>年次有給休暇取得率</span></th>
                <td class="v-middle"><div class="l-inputAccount w-short">
                  <TextBox v-model="guideCode.annualAcquisitionRate" type="text" name="guideCode.annualAcquisitionRate" @input="changeInput()"></TextBox>
                </div></td>
              </tr>
              <tr>
                <th class="v-middle"><span>平均継続勤務年数</span></th>
                <td class="v-middle"><div class="l-inputAccount w-short">
                  <TextBox v-model="guideCode.employmentYearsAve" type="text" name="guideCode.employmentYearsAve" @input="changeInput()"></TextBox>
                </div></td>
                <th class="v-middle"><span>1月あたりの平均残業時間</span></th>
                <td class="v-middle"><div class="l-inputAccount w-short">
                  <TextBox v-model="guideCode.workingHoursAve" type="text" name="guideCode.workingHoursAve" @input="changeInput()"></TextBox>
                </div></td>
              </tr>
              <tr>
                <th class="v-middle"><span>離職率</span></th>
                <td class="v-middle"><div class="l-inputAccount w-short"><TextBox v-model="guideCode.turnover" type="text" name="guideCode.turnover" @input="changeInput()"></TextBox></div></td>
                <th class="v-middle"><span>育児休業取得率</span></th>
                <td class="v-middle"><div class="l-inputAccount w-short"><TextBox v-model="guideCode.childcareRate" type="text" name="guideCode.childcareRate" @input="changeInput()"></TextBox></div></td>
              </tr>
              <tr>
                <th class="v-middle"><span>女性管理職比率</span></th>
                <td class="v-middle"><div class="l-inputAccount w-short"><TextBox v-model="guideCode.femaleManagersRatio" type="text" name="guideCode.femaleManagersRatio" @input="changeInput()"></TextBox></div></td>
                <th class="v-middle"><span>介護休業・短時間勤務取得者数</span></th>
                <td class="v-middle"><div class="l-inputAccount w-short"><TextBox v-model="guideCode.nursingCareLeave" type="text" name="guideCode.nursingCareLeave" @input="changeInput()"></TextBox></div></td>
              </tr>
              <tr>
                <th class="v-middle"><span>平均年齢</span></th>
                <td class="v-middle"><div class="l-inputAccount w-short"><TextBox v-model="guideCode.ageAve" type="text" name="guideCode.ageAve" @input="changeInput()"></TextBox></div></td>
                <th class="v-middle"><span>年間平均賃金</span></th>
                <td class="v-middle"><div class="l-inputAccount w-short"><TextBox v-model="guideCode.wageAve" type="text" name="guideCode.wageAve" @input="changeInput()"></TextBox></div></td>
              </tr>
              <tr>
                <th class="v-middle"><span>障がい者雇用率</span></th>
                <td class="v-middle"><div class="l-inputAccount w-short"><TextBox v-model="guideCode.disabilitiesRate" type="text" name="guideCode.disabilitiesRate" @input="changeInput()"></TextBox></div></td>
                <th class="v-middle"><span>財務情報</span></th>
                <td class="v-middle"><div class="l-inputAccount w-short"><TextBox v-model="guideCode.financialInformation" type="text" name="guideCode.financialInformation" @input="changeInput()"></TextBox></div></td>
              </tr>
              <tr>
                <th class="v-middle"><span>高年齢者雇用率</span></th>
                <td class="v-middle" colspan="3"><div class="l-inputAccount w-short"><TextBox v-model="guideCode.elderlyRate" type="text" name="guideCode.elderlyRate" @input="changeInput()"></TextBox></div></td>
              </tr>
<!--              <tr>
                <th class="v-middle"><span>月平均所定労働時間</span></th>
                <td class="v-middle" colspan="3"><div class="l-inputAccount w-short"><TextBox v-model="guideCode.workingHoursAve" type="text" name="guideCode.workingHoursAve" @input="changeInput()"></TextBox></div></td>
              </tr>-->
              <tr>
                <th class="v-middle"><span>労災発生件数</span></th>
                <td class="v-middle" colspan="3"><div class="l-inputAccount w-short">
                  <TextBox v-model="guideCode.accidentsCount" type="text" name="guideCode.accidentsCount" @input="changeInput()"></TextBox>
                </div></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="l-contentsBox__bottom" style="text-align: center;">
          <div class="btn-basic is-inlne is-primary js-savebtn" @click="save()" :disabled="isProcessing"><a>保存</a></div>
        </div>

      </div>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import TextBox from '@/components/parts/form/TextBox.vue';
import { saveAs } from "file-saver";
import { integer } from 'vuelidate/lib/validators';

export default {
  components: {
    Loading,
    TextBox,
  },
  data() {
    return {
      isProcessing: false,
      isRendering: false,
      fileInfo: '',
      importErrorMessages: [],
      isAnswerChanged: false,
      guideCode: {
        femalePercentage: null,
        accidentsCount: null,
        ageAve: null,
        annualAcquisitionRate: null,
        childcareRate: null,
        disabilitiesRate: null,
        elderlyRate: null,
        employmentYearsAve: null,
        femaleManagersRatio: null,
        nursingCareLeave: null,
        overtimeAve: null,
        turnover: null,
        wageAve: null,
        workingHoursAve: null,
        financialInformation: null,
      },
    }
  },
  validations: {
    guideCode: {
      femalePercentage: { 
        integer,
        guideCodeValidate: (value) => { var val = String(value); return (value == null || val.length == 0 || val.length == 4 ); } 
      },
      accidentsCount: {
        integer,
        guideCodeValidate: (value) => { var val = String(value); return (value == null || val.length == 0 || val.length == 4 ); } 
      },
      ageAve: {
        integer,
        guideCodeValidate: (value) => { var val = String(value); return (value == null || val.length == 0 || val.length == 4 ); } 
      },
      annualAcquisitionRate: {
        integer,
        guideCodeValidate: (value) => { var val = String(value); return (value == null || val.length == 0 || val.length == 4 ); } 
      },
      childcareRate: {
        integer,
        guideCodeValidate: (value) => { var val = String(value); return (value == null || val.length == 0 || val.length == 4 ); } 
      },
      disabilitiesRate: {
        integer,
        guideCodeValidate: (value) => { var val = String(value); return (value == null || val.length == 0 || val.length == 4 ); } 
      },
      elderlyRate: {
        integer,
        guideCodeValidate: (value) => { var val = String(value); return (value == null || val.length == 0 || val.length == 4 ); } 
      },
      employmentYearsAve: {
        integer,
        guideCodeValidate: (value) => { var val = String(value); return (value == null || val.length == 0 || val.length == 4 ); } 
      },
      femaleManagersRatio: {
        integer,
        guideCodeValidate: (value) => { var val = String(value); return (value == null || val.length == 0 || val.length == 4 ); } 
      },
      nursingCareLeave: {
        integer,
        guideCodeValidate: (value) => { var val = String(value); return (value == null || val.length == 0 || val.length == 4 ); } 
      },
      overtimeAve: {
        integer,
        guideCodeValidate: (value) => { var val = String(value); return (value == null || val.length == 0 || val.length == 4 ); } 
      },
      turnover: {
        integer,
        guideCodeValidate: (value) => { var val = String(value); return (value == null || val.length == 0 || val.length == 4 ); } 
      },
      wageAve: {
        integer,
        guideCodeValidate: (value) => { var val = String(value); return (value == null || val.length == 0 || val.length == 4 ); } 
      },
      workingHoursAve:{
        integer,
        guideCodeValidate: (value) => { var val = String(value); return (value == null || val.length == 0 || val.length == 4 ); } 
      },
      financialInformation:{
        integer,
        guideCodeValidate: (value) => { var val = String(value); return (value == null || val.length == 0 || val.length == 4 ); } 
      }
    }
  },

  /**
   * 初期化処理
   */
  created: function() {
    this.getHumanCapitalGuide();
  },
  /**
   * 画面遷移前　編集項目確認 
   */
  beforeRouteLeave (to, from, next) {
    if (this.isAnswerChanged) {
      const answer = window.confirm("編集中のものは保存されませんが、よろしいですか？");
      if ( answer ) {
        this.isAnswerChanged = false;
        next(answer);
      }
    } else {
      next();
    }
  },
  methods: {
    /**
     * 人的資本ガイド情報取得処理
     */
    async getHumanCapitalGuide() {
      this.isProcessing = true;
      this.isRendering = true;
      let res = await this.$axios.post('/ld/api/master/human_capital/getHumanCapitalGuide', {
      });
      if (res) {
        if ( res.data.guideCode != null ) this.guideCode = res.data.guideCode;
      }
      this.$nextTick(() => {
        this.isRendering = false;
        this.isProcessing = false;
      });
    },
    fileSelected(event) {
      this.fileInfo = event.target.files[0];
    },
    /**
     * 平均値ファイルアップロード
     */
    async fileUpload() {
      this.isProcessing = true;
      this.importErrorMessages = [];
      if (!this.fileInfo) {
        this.$toast.error("ファイルを選択してください");
        this.isProcessing = false;
        return;
      }
      const formData = new FormData();
      formData.append('file', this.fileInfo);

      let res = await this.$axios.post('/ld/api/master/human_capital/upload', formData);
      if (res.status === 200) {
        this.$toast.info('登録が完了しました');
      } else {
        this.$toast.error('取込みデータが不正です');
        this.importErrorMessages = res.data.message
      }
      document.getElementById('upload').value = ''
      this.fileInfo = null;
      this.isProcessing = false;
    },
    /**
     * ガイドコードの保存
     */
    async save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/master/human_capital/save', {
          guideCode: this.guideCode
        });
        if (res.status === 200) {
          this.$toast.info('登録が完了しました');
          this.isAnswerChanged = false;
        } else {
          this.$toast.error(res.data.message);
        }
        this.isProcessing = false;
      }else {
        this.$toast.error('入力データが不正です。');
      }
    },
    /**
     * 平均値フォーマットファイルのダウンロード処理
     */
    async templateCsvFileDownload() {
      this.$toast.info('ダウンロードを開始しました。');
      await saveAs('/ld/api/master/human_capital/templateCsvFileDownload');
    },
    /**
     * 値編集チェック用フラグ
     */
    changeInput(){
      this.isAnswerChanged = true;
    }
  },
}

</script>

<style scoped>
.guidesearch-fade-enter-active {
  transition: height .1s ease-in-out;
}
.guidesearch-fade-leave-active {
  transition: height .1s ease-in-out;
}
.guidesearch-fade-enter-to, .guidesearch-fade-leave {
  overflow: hidden;
}
.guidesearch-fade-enter, .guidesearch-fade-leave-to {
  overflow: hidden;
}
</style>
